export const CAPSULE_LOGO_URL = "/capsule-corp-logo.png";
